import PropTypes from 'prop-types';

import Container from '../../../Core/Container';
import { FeatureCards } from '../../Card-Sections/FeatureCards';

import { Wrapper, Controls, Search } from './styles';

const FAQSearchSection = ({ data }) => {
  if (!data) return null;
  const {
    faqSearchHeading,
    faqSearchFieldText,
    faqFeatureBlockSection,
    inputAria,
  } = data;
  return (
    <Container>
      <Wrapper>
        <h2>{faqSearchHeading}</h2>
        <Controls>
          <Search
            type="is-open"
            placeholder={faqSearchFieldText}
            predictiveSearch
            predictiveSearchClass="centered-results"
            arialabel={inputAria}
          />
        </Controls>
      </Wrapper>
      <FeatureCards
        data={faqFeatureBlockSection}
        containerClass="no-margin inner-container"
      />
    </Container>
  );
};

FAQSearchSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default FAQSearchSection;
